import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import throttle from 'lodash/throttle.js';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.navs = [];
    _this.activeIndex = 0;
    _this.fixHeight = 400; // 额外追加高度，元素顶部距离视口顶部达到该值时，即表面该锚点已到达（不用非得是0）

    _this.shouldNavFixed = false;
    _this.isPro = PROJECT_ENV.ENV === 'prod';
    _this.step = 10;
    _this.targetPos = 0;
    _this.scrollTimer = 0;
    _this.isAutoScrolling = false;
    return _this;
  }

  _createClass(Index, [{
    key: "mounted",
    value: function mounted() {
      // document.addEventListener('DOMContentLoaded', this.initNav);
      setTimeout(this.initNav, 0);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('scroll', this.locNavCursorOnScroll);
      window.removeEventListener('resize', this.locNavCursorOnResize);
    }
  }, {
    key: "initNav",
    value: function initNav() {
      var _this2 = this;

      this.getInitialDataUsedByNav(); // 滚动

      window.addEventListener('scroll', this.locNavCursorOnScroll = throttle(function () {
        var scrollTop = _this2.getScrollTop(); // nav是否该fixed


        _this2.checkNavFixed(scrollTop); // 设置当前应激活Anchor


        _this2.checkActiveIndex(scrollTop);
      }, 60)); // 页面窗口调整大小时

      window.addEventListener('resize', this.locNavCursorOnResize = function () {
        _this2.getInitialDataUsedByNav();

        _this2.locNavCursorOnScroll();
      }); // 用户鼠标滚动的时候停止自动scroll

      window.addEventListener('wheel', function (event) {
        if (_this2.isAutoScrolling) {
          clearTimeout(_this2.scrollTimer);
          _this2.isAutoScrolling = false;
        }
      }); // 初始执行一次（避免刷新问题）

      this.locNavCursorOnScroll();
    }
  }, {
    key: "getInitialDataUsedByNav",
    value: function getInitialDataUsedByNav() {
      var navs = [];
      var scrollTop = this.getScrollTop();
      document.querySelectorAll('.js-view-module').forEach(function (el) {
        var elSubject = el.querySelector('.js-view-module-subject');
        navs.push({
          el: el,
          name: elSubject && elSubject.innerHTML,
          top: scrollTop + el.getBoundingClientRect().top
        });
      });
      this.navs = navs;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
  }, {
    key: "checkNavFixed",
    value: function checkNavFixed(scrollTop) {
      var limit = this.navs[0].top;

      if (scrollTop >= limit) {
        this.shouldNavFixed = true;
      } else {
        this.shouldNavFixed = false;
      }
    }
  }, {
    key: "checkActiveIndex",
    value: function checkActiveIndex(scrollTop) {
      var _this3 = this;

      var activeIndex;
      this.navs.forEach(function (item, index) {
        if (scrollTop + _this3.fixHeight >= item.top) {
          activeIndex = index;
        }
      });

      if (scrollTop === 0 && activeIndex !== 0) {
        activeIndex = 0;
      }

      this.activeIndex = activeIndex || 0;
    }
  }, {
    key: "goToCertainPage",
    value: function goToCertainPage(index) {
      var targetModule = document.querySelectorAll('.js-view-module')[index];
      var fixedVar = 80; // 调整量
      // @ts-ignore

      this.targetPos = this.getScrollTop() + targetModule.getBoundingClientRect().top - fixedVar;
      this.isAutoScrolling = true;

      if (typeof window.getComputedStyle(document.body).scrollBehavior === 'undefined') {
        // 不兼容smooth使用传统js滚动
        this.traditionalScroll();
      } else {
        window.scrollTo({
          top: this.targetPos,
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "traditionalScroll",
    value: function traditionalScroll() {
      // @ts-ignore
      var scrollTop = window.scrollTop || document.documentElement.scrollTop;
      var toPos = (this.targetPos - scrollTop) / this.step + scrollTop;

      if (Math.abs(this.targetPos - scrollTop) < this.step) {
        toPos = this.targetPos;
        this.isAutoScrolling = false;
      } else {
        this.scrollTimer = setTimeout(this.traditionalScroll, 16);
      }

      window.scrollTo(0, toPos);
    }
  }]);

  return Index;
}(Vue);

Index = __decorate([Component({
  name: 'ViewNav',
  components: {}
})], Index);
export default Index;